import React from "react";

import {useACFOptions} from "/src/components/_hooks/useACFOptions";

import {Section} from "/src/_v2/ui/layout/Section";
import {Container} from "/src/_v2/ui/layout/Container";
import {Text} from "/src/_v2/ui/primitives/Text";
import {ParagraphTags} from "/src/_v2/ui/patterns/ParagraphTags";

import {SubscribeForm} from "/src/_v2/ui/patterns/SubscribeForm";

export const SubscribeSection = ({index, color = 'pink'}) => {
  index = index || '04.';

  const { subscribe } = useACFOptions();

  const {suptitle, title, text} = subscribe;

  return (
    <Section>
      <Container>
        <div className="tw:border tw:border-bw-50 tw:rounded-2xl tw:grid tw:gap-20 tw:md:gap-32 tw:lg:grid-cols-12 tw:lg:gap-24 tw:px-20 tw:py-32 tw:md:px-32 tw:md:py-40 tw:xl:py-64 tw:xl:px-0">
          <div className="tw:lg:col-span-6 tw:xl:col-span-5 tw:xl:col-start-2">
            <div className="tw:space-y-8 tw:md:space-y-12">
              <ParagraphTags prefix={index} text={suptitle} color={color}/>
              {title && (
                <h2 className="tw:h3">{title}</h2>
              )}
            </div>
          </div>
          <div className="tw:lg:col-span-6 tw:xl:col-span-5 tw:flex tw:flex-col tw:gap-32 tw:xl:gap-24 tw:self-end">
            <Text text={text} />
            <SubscribeForm portalId={subscribe.portalId} formId={subscribe.formId} />
          </div>
        </div>
      </Container>
    </Section>
  )
}
